<template lang="pug">
  .component-backoffice-fuel-type
    selectize(:options="fuelTypes", @itemAdded="selected", :maxItems="1")
</template>
<script type="text/babel">
  import Selectize from "../../Selectize";

  export default {
    name: "FuelTypeSelect",
    components: {
      Selectize,
    },
    data() {
      return {
        fuelTypes: [
          {id: 'PETROL', name: 'PETROL'},
          {id: 'DIESEL', name: 'DIESEL'},
          {id: 'HYBRID', name: 'HYBRID'},
          {id: 'GAS', name: 'GAS'},
          {id: 'ELECTRIC', name: 'ELECTRIC'},
          {id: 'HYDROGEN', name: 'HYDROGEN'},
          {id: 'NONE', name: 'NONE'},
          {id: 'OTHER', name: 'OTHER'},
        ]
      }
    },
    created() {
    },
    methods: {
      selected(id) {
        this.$emit('fuelTypeSelected', id)
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// FuelTypeSelect.vue?121cdd33